import userApi from '@/api/user';
import { v4 as uuidv4 } from 'uuid';

const VISITOR_TOKEN_KEY = 'ocs_visitor_token';

function ensureVisitorToken() {
  let t = localStorage.getItem(VISITOR_TOKEN_KEY);
  if (!t || t.length < 1) {
    t = uuidv4();
    localStorage.setItem(VISITOR_TOKEN_KEY, t);
  }
  return t;
}

export default {

  async login() {

    try {
      const visitorToken = ensureVisitorToken();
      console.log('services.login, visitorToken:', visitorToken);
      const response = await userApi.login(1000, visitorToken);
      console.log('services.login, response:', response);
      if (response && response.status === 200) {
          const rsp = response.data;
          localStorage.setItem("ocs_user_token", rsp.token);
          if (rsp.visitorToken && rsp.visitorToken.length > 0) {
            localStorage.setItem(VISITOR_TOKEN_KEY, rsp.visitorToken);
          }
          if (rsp.visitorId && rsp.visitorId.length > 0) {
            localStorage.setItem("ocs_visitor_id", rsp.visitorId);
          }
          return rsp;
      }
      throw new Error('login, response:', response);
    } catch (error) {
      console.error('login, error:', error);
      // 错误处理逻辑
      throw error;
    }
  },
};
